// removed by extract-text-webpack-plugin
module.exports = {"title":"XBSBzBqcaWSbSYHBxcp6X","content":"_2hzQyZ4DwpDS7WrWjmF2jF","panel":"_147ZsWkOL9SiBVqu318oYF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Panel.scss
// module id = 1285
// module chunks = 1